import {useState} from 'react';
import {Button} from 'rsuite';
import {RiToolsIcon} from '../../../models/Icons.model';
import {isVerboxEnabled} from './VerboxChat';
import {getMaintenanceDate, MaintenanceDevice, needsMaintenance, openMaintenanceChat} from './maintenanceChat';
import './MaintenanceChatNotice.scss';

export default function MaintenanceChatNotice({device, deviceId}: {
  device: MaintenanceDevice | null;
  deviceId?: string;
}) {
  const [error, setError] = useState('');
  const [opening, setOpening] = useState(false);
  // While a new card is loading, the page may still contain the old device.
  if (!device || !deviceId || String(device.id) !== deviceId || !needsMaintenance(device.nextMaintenanceDate)) {
    return null;
  }

  const openChat = async () => {
    setError('');
    setOpening(true);
    try {
      const url = new URL(window.location.href);
      url.search = '';
      url.hash = '';
      await openMaintenanceChat(device, url.href);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Не удалось открыть чат. Попробуйте ещё раз.');
    } finally {
      setOpening(false);
    }
  };

  return (
    <section className="maintenance-chat-notice" aria-label="Техническое обслуживание">
      <div className="maintenance-chat-notice__content">
        <RiToolsIcon aria-hidden="true" />
        <div>
          <strong>Требуется ТО</strong>
          <div>Дата обслуживания: {getMaintenanceDate(device.nextMaintenanceDate).format('DD.MM.YYYY')}. Обратитесь в сервисный центр.</div>
        </div>
      </div>
      {isVerboxEnabled && (
        <Button appearance="primary" loading={opening} disabled={opening} onClick={openChat}>
          Написать в сервисный центр
        </Button>
      )}
      {error && <div className="maintenance-chat-notice__error" role="alert">{error}</div>}
    </section>
  );
}
